import { TextField } from '@material-ui/core';
import React  from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { Controller } from 'react-hook-form';
import { NUMBER_FORMAT } from '../../../utils/validate';
import { useTranslation } from 'react-i18next';

const ObjectiveKPIForm = () => {
  const { t } = useTranslation();

  return <>
    <Controller
      name='name'
      defaultValue=''
      rules={ {
        required: {
          value: true,
          message: 'required'
        }
      } }
      render={ ({
        field: { onChange, value },
        fieldState: { error }
      }) => (
        <TextField
          label={ t('objective.kpi.fields.name') }
          value={ value }
          onChange={ onChange }
          margin='dense'
          fullWidth
          error={ !!error }
          helperText={ error?.message && t(`form.errors.${error.message}`) }
        />
      ) }
    />
    <div style={ {
      margin: '16px 0',
      display: 'flex',
      justifyContent: 'space-between',
      gridGap: 16
    } }>
      <Controller
        name='goalValue'
        defaultValue=''
        rules={ {
          required: {
            value: true,
            message: 'required'
          },
          pattern: {
            value: NUMBER_FORMAT,
            message: 'notNumber'
          },
          min: {
            value: 0,
            message: 'isNegative'
          }
        } }
        render={ ({
          field: { onChange, value },
          fieldState: { error }
        }) => (
          <TextField
            label={ t('objective.kpi.fields.goalValue') }
            value={ value }
            onChange={ onChange }
            margin='dense'
            fullWidth
            error={ !!error }
            helperText={ error?.message && t(`form.errors.${error.message}`) }
          />
        ) }
      />
      <Controller
        name='unit'
        defaultValue=''
        rules={ {
          required: {
            value: true,
            message: 'required'
          }
        } }
        render={ ({
          field: { onChange, value },
          fieldState: { error }
        }) => (
          <TextField
            label={ t('objective.kpi.fields.unit') }
            value={ value }
            onChange={ onChange }
            margin='dense'
            fullWidth
            error={ !!error }
            helperText={ error?.message && t(`form.errors.${error.message}`) }
          />
        ) }
      />
    </div>
    <Controller
      name='deadline'
      rules={ {
        required: {
          value: true,
          message: 'required'
        }
      } }
      defaultValue={ new Date() }
      render={ ({
        field: { onChange, value },
        fieldState: { error }
      }) => (
        <KeyboardDatePicker
          value={ value }
          onChange={ date => onChange(date) }
          minDate={ new Date() }
          format="yyyy/MM/dd"
          autoOk={ true }
          disableToolbar
          label={ t('objective.kpi.fields.deadline') }
          variant="inline"
          margin='dense'
          fullWidth
          error={ !!error }
          helperText={ error?.message && t(`form.errors.${error.message}`) }
        />
      ) }
    />
  </>;
};

export default ObjectiveKPIForm;